module.exports = __webpack_public_path__ + "static/media/guedes.b0e94783.jpg";